<template>
  <div v-if="isDisplay" class="fac-colona-measures">
    <h2>
      <img src="/images/icon_disinfection.svg" alt="" />
      新型コロナウイルス感染症対策について
    </h2>
    <p>
      新型コロナウイルス感染症(COVID-19)の影響により、施設をご利用の際に下記の制限がございます。
    </p>
    <ul>
      <li v-for="(value, index) in filteredInfectionInfo" :key="index">
        {{ value }}
      </li>
    </ul>
    <p v-if="detail.infection_info.comment">
      <span class="nl2br">{{ detail.infection_info.comment }}</span>
    </p>
    <p v-if="detail.infrection_survey_date" class="date">
      ※
      {{
        detail.infrection_survey_date | date_format('YYYY年M月D日')
      }}時点の情報です。施設からは上記以外の制限および注意事項がある場合がございます。最新の情報につきましては、施設に直接お問い合わせいただきご確認ください。
    </p>
  </div>
</template>

<script>
import { config } from '@/utils/config'
export default {
  props: {
    detail: {
      type: Object,
      required: true
    }
  },
  computed: {
    filteredInfectionInfo() {
      const infoList = []
      for (const key of Object.keys(this.detail.infection_info)) {
        if (key !== 'comment') {
          const val = this.detail.infection_info[key]
          if (
            config.infectionInfoMessages[key] &&
            config.infectionInfoMessages[key][val]
          ) {
            infoList.push(config.infectionInfoMessages[key][val])
          }
        }
      }
      return infoList
    },
    isDisplay() {
      if (
        Object.keys(this.detail.infection_info).length >= 1 &&
        this.detail.infrection_survey_date
      ) {
        return true
      }
      return false
    }
  }
}
</script>
